<app-icon-confirm-dialog
  icon="pi pi-calendar-plus"
  tooltipKey="project.steps.invitationList.updateSubmissionDate"
  header="project.steps.invitationList.updateSubmissionDate.title"
  testId="update-submission-date-dialog"
  [confirmHidden]="!selectedDate()"
  (opened)="onOpened()"
  (confirm)="confirm()"
>
  <app-model-field-datepicker
    id="update-submission-date"
    label="project.steps.invitationList.submissionDate"
    [smallLabel]="true"
    [isRequired]="true"
    [minDate]="minDate()"
    [value]="selectedDate()"
    (valueChange)="selectedDate.set($event)"
  />
</app-icon-confirm-dialog>
